<template>
    <div class="page-cabinet-verification-profile-photos">
        <common-collapsible
            title="Паспорт"
            v-bind:attention="!isValid ? 'Загрузите документы' : ''"
            init-open
            start-collapsed-on-mobile
        >
            <div class="page-cabinet-verification-profile-photos__loaders">
                <common-file-loader-2
                    title="Разворот с персональными данными (2 и 3 страница)"
                    v-bind:file="photoPassportFirst"
                    v-bind:is-loading="photoPassportFirstIsLoading"
                    v-bind:given-error="photoPassportFirstError"
                    v-bind:required="true"
                    v-on:change="updatePhoto($event, 'photoPassportFirst')"
                    v-on:delete="deletePhoto($event, 'passport-first')"
                />
                <common-file-loader-2
                    title="Разворот с действующей регистрацией"
                    description="В случае отсутствия постоянной регистрации, прикрепите скан пустых страниц из паспорта, а скан временной регистрации загрузите в окно ниже."
                    v-bind:file="photoPassportRegistration"
                    v-bind:is-loading="photoPassportRegistrationIsLoading"
                    v-bind:given-error="photoPassportRegistrationError"
                    v-bind:required="true"
                    v-on:change="updatePhoto($event, 'photoPassportRegistration')"
                    v-on:delete="deletePhoto($event, 'passport-registration')"
                />
                <common-file-loader-2
                    title="Временная регистрация"
                    v-bind:file="photoTemporaryRegistration"
                    v-bind:is-loading="photoTemporaryRegistrationIsLoading"
                    v-bind:given-error="photoTemporaryRegistrationError"
                    v-on:change="updatePhoto($event, 'photoTemporaryRegistration')"
                    v-on:delete="deletePhoto($event, 'temporary-registration')"
                />
            </div>
        </common-collapsible>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { mainClient } from '~/network';

export default {
    name: 'page-cabinet-verification-profile-photos',
    props: {
        isTouched: {
            type: Boolean,
        },
    },
    data: () => ({
        photoPassportFirstIsLoading: false,
        photoPassportRegistrationIsLoading: false,
        photoTemporaryRegistrationIsLoading: false,
        photoPassportFirstIsError: false,
        photoPassportRegistrationIsError: false,
        photoTemporaryRegistrationIsError: false,
    }),
    computed: {
        ...mapState('verification/type', [
            'legalType',
        ]),
        ...mapState('users', [
            'getUserProfileResult',
            'getUserProfileIsLoading',

            'getUserPhotosResult',
            'getUserPhotosIsLoading',
        ]),
        user() {
            return this.$store.getters['users/user'];
        },
        photoPassportFirst() {
            return this.getUserPhotosResult?.photoPassportFirst;
        },
        photoPassportRegistration() {
            return this.getUserPhotosResult?.photoPassportRegistration;
        },
        photoTemporaryRegistration() {
            return this.getUserPhotosResult?.photoTemporaryRegistration;
        },
        isValid() {
            return this.photoPassportRegistration && this.photoPassportFirst;
        },
        photoPassportFirstError() {
            if (this.isTouched && !this.photoPassportFirst) {
                return 'Загрузите фото';
            }
            if (this.photoPassportFirstIsError) {
                return 'Произошла ошибка при загрузке файла';
            }
            return null;
        },
        photoPassportRegistrationError() {
            if (this.isTouched && !this.photoPassportRegistration) {
                return 'Загрузите фото';
            }
            if (this.photoPassportRegistrationIsError) {
                return 'Произошла ошибка при загрузке файла';
            }
            return null;
        },
        photoTemporaryRegistrationError() {
            if (this.photoTemporaryRegistrationIsError) {
                return 'Произошла ошибка при загрузке файла';
            }
            return null;
        },
        userLegalType() {
            return this.legalType || this.getUserProfileResult.legalType;
        },
    },
    methods: {
        updatePhoto(file, type) {
            if (file !== null) {
                const formData = new FormData();
                formData.append('image_file', file);
                this[type + 'IsLoading'] = true;
                this[type + 'IsError'] = false;
                this.$store.dispatch('users/updateUserPhoto', {
                    userId: this.user.id,
                    type,
                    formData,
                    isBackground: true,
                    onSuccess: () => {
                        this.$store.dispatch('users/getUserPhotos', {
                            userId: this.user.id,
                            onSuccess: () => {
                                this[type + 'IsLoading'] = false;
                            },
                        });
                    },
                    onError: () => {
                        this[type + 'IsLoading'] = false;
                        this[type + 'IsError'] = true;
                    },
                });
            }
        },
        async deletePhoto(file) {
            await mainClient.users.requests.deleteUserPhoto({
                userId: this.user.id,
                photoId: file.id,
            });
            this.$store.dispatch('users/getUserPhotos', {
                userId: this.user.id,
            });
        },
    },
    watch: {
        isValid: {
            handler(newVal) {
                this.$emit('validation-update', { entityName: 'isPhotosDataValid', value: !!newVal });
            },
            immediate: true,
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-cabinet-verification-profile-photos {
    &__headline {
        display: flex;
        margin-bottom: 16px;

        align-items: center;
    }
    &__loaders {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }
}
</style>
